// Languages a coding question can allow; ids are what questionContent.languages stores
export const CODING_LANGUAGES = [
  { id: 'c', label: 'C' },
  { id: 'cpp', label: 'C++' },
  { id: 'java', label: 'Java' },
  { id: 'javascript', label: 'JavaScript' },
  { id: 'typescript', label: 'TypeScript' },
  { id: 'python', label: 'Python' },
];

export const languageLabel = (id) => CODING_LANGUAGES.find(l => l.id === id)?.label || id;

// Programs read stdin and print stdout, so starters are plain mains
export const DEFAULT_STARTER_CODE = {
  c: '#include <stdio.h>\n\nint main() {\n    // read input, print output\n    return 0;\n}\n',
  cpp: '#include <bits/stdc++.h>\nusing namespace std;\n\nint main() {\n    // read input, print output\n    return 0;\n}\n',
  java: 'import java.util.*;\n\npublic class Main {\n    public static void main(String[] args) {\n        Scanner sc = new Scanner(System.in);\n        // read input, print output\n    }\n}\n',
  javascript: "const lines = require('fs').readFileSync(0, 'utf8').trim().split('\\n');\n// read input, print output\n",
  typescript: "const lines: string[] = require('fs').readFileSync(0, 'utf8').trim().split('\\n');\n// read input, print output\n",
  python: 'import sys\n\ndata = sys.stdin.read().split()\n# read input, print output\n',
};

export const DEFAULT_MEMORY_LIMIT_MB = 256;
export const DEFAULT_TIME_LIMIT_MS = 1000;

export const newTestCase = (hidden = false) => ({
  id: `tc_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
  name: '',
  input: '',
  expectedOutput: '',
  hidden,
  weight: 1,
  timeLimitMs: DEFAULT_TIME_LIMIT_MS,
});

// Content of a new coding question; statement comes from the shared editor
export const emptyCodingContent = (statement = null) => ({
  questionContent: {
    statement,
    title: '',
    difficulty: 'Medium',
    constraints: '',
    inputFormat: '',
    outputFormat: '',
    languages: CODING_LANGUAGES.map(l => l.id),
    starterCode: { ...DEFAULT_STARTER_CODE },
  },
  answerContent: {
    testCases: [newTestCase(false)],
    memoryLimitMb: DEFAULT_MEMORY_LIMIT_MB,
  },
});
